/*-------------------------------------------------------------------
|  🐼 React CTX DictionaryContext
|
|  🐯 Purpose: HANDLES DICTIONARY STATES GLOBALLY
|
|  🐸 Returns: CTX PROVIDER / CTX HOOK
*-------------------------------------------------------------------*/

import { useContext, createContext, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { _getTr, _getRm } from '../api/dictionary'
import { useModifiedSWR } from '../hooks'

const DictionaryContext = createContext()

export function DictionaryProvider({ children }) {
  const params = useParams()
  const [word, setWord] = useState('')
  const [language, setLanguage] = useState('tr')

  useEffect(() => {
    setWord(params.word || null)
    setLanguage(params.language || 'tr')
  }, [params.word, params.language])

  useEffect(() => {
    // "document.documentElement.scrollTo" is the magic for React Router Dom v6
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth', // Optional if you want to skip the scrolling animation
    })
  }, [word, language])

  const { data, isLoading, isError } = useModifiedSWR(
    word ? (language === 'rm' ? _getTr(word) : _getRm(word)) : null,
  )

  return (
    <DictionaryContext.Provider
      value={{
        language,
        setLanguage,
        word,
        setWord,
        data,
        isLoading,
        errorStatus: isError?.response?.status,
      }}
    >
      {children}
    </DictionaryContext.Provider>
  )
}

export function useDictionary() {
  return useContext(DictionaryContext)
}
